import { cn } from "@/lib/utils";

/** The round Milqit badge at icon size. Decorative: pair it with a name. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/images/brand/milqit-badge-128.png"
      alt=""
      width={32}
      height={32}
      className={cn("aspect-square size-8 shrink-0", className)}
    />
  );
}
